import { httpV2 } from "../http";

const StorageService = {
  listLocations: (params) => httpV2.get("/storage/locations", { params }),
  createLocation: (location) => httpV2.post("/storage/locations", location),
  updateLocation: (locationId, location) => httpV2.put(`/storage/locations/${locationId}`, location),
  deleteLocation: (locationId) => httpV2.delete(`/storage/locations/${locationId}`),
  listItems: (params) => httpV2.get("/storage/items", { params }),
  createItem: (item) => httpV2.post("/storage/items", item),
  updateItem: (itemId, item) => httpV2.put(`/storage/items/${itemId}`, item),
  deleteItem: (itemId) => httpV2.delete(`/storage/items/${itemId}`),
  listStock: (params) => httpV2.get("/storage/stock", { params }),
  createStockAction: (action) => httpV2.post("/storage/stock/actions", action),
  listMovements: (params) => httpV2.get("/storage/movements", { params }),
  inventoryHealth: () => httpV2.get("/storage/health"),
  inventoryValueReport: (params) => httpV2.get("/storage/reports/value", { params }),
  inventoryLossReport: (params) => httpV2.get("/storage/reports/loss", { params }),
  lowStockReport: (params) => httpV2.get("/storage/reports/low-stock", { params }),
};

export default StorageService;
